import { Component, ElementRef, EventEmitter, Inject, Injector, Input, OnInit, Output, ViewChild, TemplateRef } from '@angular/core';
import { FormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AbstractCreateEntityComponent } from '@abstracts/entities/create-entity';
import { UsersService } from '@services/entity/users.service';
import { User } from '@models/identity/user';
import { SendInviteRequest } from '@dto/sendInviteRequest';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { DOCUMENT, NgIf } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { PricingsService } from '@services/entity/pricings.service';
import { PricingDto } from '@dto/pricingDto';
import { plainToClass } from 'class-transformer';
import { StripeInfosService } from '@services/entity/stripe-infos.service';
import { StripeInfo } from '@models/stripeInfo';
import { RfidCardDto } from '../../../../dto/rfidCardDto';
import { Tag } from '../../../../models/tag';
import { RfidCardsService } from '../../../../services/entity/rfidCards.service';
import { RfidCard } from '../../../../models/rfidCard';
import { validate } from 'compare-versions';
import { resolve } from 'dns';
import { ToastService } from '../../../../services/toast/toast.service';
import { Roles } from '../../../../enums/roles.enum';
import { Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { ExistDummyRequestDto } from '../../../../dto/existDummyRequestDto';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.scss']
})
export class CreateUserComponent extends AbstractCreateEntityComponent implements OnInit {

  public className = 'CreateUserComponent'
  show: boolean;
  public oldrfidCards: RfidCardDto[];
  public availableRfidCards: RfidCardDto[];
  public assignedRfidCards: RfidCardDto[];
  public tags: Tag[];
  public addTagRef: (name) => void;
  rfidTagMaxLength = 20;
  rfidTagMinLength = 8;
  condition: boolean = false;
  error: boolean = false;
  errorMessage = " <= min. 8-Zeichen ";
  btnSaveDisabled: boolean = false;
  assignedRfidCardIdTags: string[] = [];

  cacheIdTag: string;

  @Input() customerId: number;
  @Output() newUserEvent = new EventEmitter<User>();
  @Output() newAnonymousUserEvent = new EventEmitter<User>();
  public inviteLink: string;

  mailTemplate: TemplateRef<any> | null = null;
  @ViewChild('primaryTemplate')
  primaryTemplate: TemplateRef<any> | null = null;

  @ViewChild('secondaryTemplate')
  userTemplate: TemplateRef<any> | null = null;
  public emailExists: boolean;

  constructor(
    @Inject('BASE_URL') private baseUrl: string,
    public toastService: ToastService,
    private usersService: UsersService,
    private rfidCardsService: RfidCardsService,
    private spinner: NgxSpinnerService,
    private stripeInfosService: StripeInfosService,
    injector: Injector
  ) {
    super(usersService, injector);
    this.show = true;
    this.mailTemplate = this.primaryTemplate;
    this.addTagRef = this.addTagPromise.bind(this);
  }

  ngOnInit() {
    this.mailTemplate = this.primaryTemplate;
    super.ngOnInit()
    this.getRfidCardsOfCurrent();

    this.formService.form.get('selectedTags').valueChanges
      .pipe(distinctUntilChanged())
      .subscribe(tags => {
        console.log('RFID-Eintrag hat sich geändert:', tags);
      });
  }

  async onSubmit(formValue) {
    this.btnSaveDisabled = true;

    var user = new User(formValue);
    var existDummyRequestDto: ExistDummyRequestDto = { customerId: this.customerId, firstName: user.firstName.trim(), lastName: user.lastName.trim() };
    var email = this.formService.form.get('email').value;

    var existEmail = await this.usersService.existEmail(email).toPromise();
    var existDummyUser = await this.usersService.existDummyUser(existDummyRequestDto).toPromise();

    if (existEmail) {
      this.toastService.error($localize`:@@EmailExist:E-Mail-Adresse existiert bereits.`, 5500, true);
      this.btnSaveDisabled = false;
      return;
    }

    if (existDummyUser) {
      this.toastService.error($localize`:@@DummyExist: Dieser Benutzer existiert bereits.`, 5500, true);
      this.btnSaveDisabled = false;
      return;
    }

    this.toastService.clear();

    user.rfidCards = (formValue.selectedTags as RfidCard[])

    if (this.formService.form.get('email').value.length > 0) {
      if (this.customerId) {
        this.usersService.createUserForCustomer(this.customerId, user).subscribe(newUser => {
          this.sendInviteEmail(user);
          this.toastService.clear();
        }, error => {
          this.btnSaveDisabled = false;
          this.toastService.clear();
        });
      }
      else {
        this.usersService.createUserForCurrentCustomer(user).subscribe(newUser => {
          this.sendInviteEmail(user);
          this.toastService.clear();
          this.btnSaveDisabled = false;
        }, error => {
          this.btnSaveDisabled = false;
          this.toastService.clear();
        });
      }
    }
    else {
      if (this.customerId) {
        this.usersService.createAnonymousUserForCustomer(this.customerId, user).subscribe(data => {
          this.newAnonymousUserEvent.emit(user);
          this.toastService.clear();
          this.btnSaveDisabled = false;
        }, error => {
          this.btnSaveDisabled = false;
          this.toastService.clear();
        });
      }
      else {
        var temp = this.usersService.createAnonymousUserForCurrentCustomer(user).subscribe(data => {
          this.newAnonymousUserEvent.emit(user);
          this.toastService.clear();
          this.btnSaveDisabled = false;
        }, error => {
          this.btnSaveDisabled = false;
          this.toastService.clear();
        });
      }
    }
  }

  ngSelect_KeypressEvent(event: any) {
    const tagInput = document.getElementById('tags-input');
    tagInput.classList.remove('error-key');

    if (this.isCharAllowed(event.keyCode) === false) {
      event.preventDefault();
      window.setTimeout(() => tagInput.classList.add('error-key'), 10);
    }

    else if ((event.target.value.length + 1) > this.rfidTagMaxLength) {
      event.preventDefault();
    }

  }

  ngSelect_KeyupEvent(event: any) {

    event.target.value = event.target.value.toLowerCase();
    this.error = !this.isRfidCardIdTagValid(event.target.value);

    this.condition = this.isRfidCardIdTagConditionMet(event.target.value);
  }

  ngSelect_InputEvent(event: Event) {
    this.toastService.clear();
    const inputValue = (event.target as HTMLInputElement).value;
    const regexNonHex: RegExp = /[^0-9a-fA-F]/g;

    if (regexNonHex.test(inputValue)) {
      (event.target as HTMLInputElement).value = inputValue.replace(regexNonHex, '');
      this.toastService.error(`Eingabefehler: Es sind nur hexadezimale Zeichen erlaubt.`, 0, true);
    }

    if (this.isRfidCardIdTagAvailable(inputValue) == false) {
      this.toastService.error("RFID ist bereits vergeben: " + (inputValue == null ? "" : inputValue), 0, true);
    }

    const selectedTags = this.formService.form.get('selectedTags')?.value ?? [];
    if (Array.isArray(selectedTags) && selectedTags.some(card => card.idTag.toLowerCase() === inputValue)) {
      this.showToastRfidCardAlreadyEntered(inputValue);
    }

    this.cacheIdTag = inputValue;
  }

  ngSelect_PastEvent(event: ClipboardEvent) {
    const tagInput = document.getElementById('tags-input');
    tagInput.classList.remove('error-key');

    if (this.isRfidCardIdTagValid(event.clipboardData?.getData('text')) === false) {
      event.preventDefault();
      window.setTimeout(() => tagInput.classList.add('error-key'), 10);

    }
    this.condition = this.isRfidCardIdTagAvailable(event.clipboardData?.getData('text'));
  }

  onBlur() {

    if (this.cacheIdTag == null || this.cacheIdTag.length <= 0)
      return;

    if (this.isRfidCardIdTagValid(this.cacheIdTag) == false) {
      this.toastService.error("Ungültige RFID: " + (this.cacheIdTag == null ? "" : this.cacheIdTag), 0, true);
      this.cacheIdTag = "";
      return;
    }

    if (this.isRfidCardIdTagAvailable(this.cacheIdTag) == false) {
      this.toastService.error("RFID ist bereits vergeben: " + (this.cacheIdTag == null ? "" : this.cacheIdTag), 0, true);
      this.cacheIdTag = "";
      return;
    }

    const selectedTags = this.formService.form.get('selectedTags')?.value ?? [];
    if (Array.isArray(selectedTags) && selectedTags.some(card => card.idTag.toLowerCase() === this.cacheIdTag)) {
      this.showToastRfidCardAlreadyEntered(this.cacheIdTag);
      this.cacheIdTag = "";
      return;
    }


    try {

      let newRfidCard: RfidCardDto = plainToClass(RfidCardDto, { customerId: this.customerId, idTag: this.cacheIdTag });

      const currentRfidIdTag = this.formService.form.get('selectedTags').value || [];
      const updatedRfidIdTag = [...currentRfidIdTag, newRfidCard];
      this.formService.form.get('selectedTags').setValue(updatedRfidIdTag);

    } catch (e) {

    } finally {
      this.cacheIdTag = "";
    }
  }

  createForm() {
    this.formService.form = new UntypedFormGroup({
      UserType: new UntypedFormControl(''),
      firstName: new UntypedFormControl('', [Validators.required, Validators.maxLength(50)]),
      lastName: new UntypedFormControl('', [Validators.required, Validators.maxLength(50)]),
      selectedTags: new UntypedFormControl(''),
      email: new UntypedFormControl('', [Validators.email])
      // pricing: new UntypedFormControl(''),

    });
  }

  checkEmail() {
    var email = this.formService.form.get('email').value;
    if (email != "") {
      this.usersService.checkIfEmailExists(email).subscribe(result => {
        this.emailExists = result;
        if (this.emailExists) {
          this.formService.form.setErrors({ emailExists: 'E-Mail existiert bereits' });
          return false;
        }
      }, error => {
        console.error(error);
      })
    } else {
      this.emailExists = false;
      return true;
    }
  }

  filterAvailableRfidCards(rfidCardDtos: RfidCardDto[]): RfidCardDto[] {
    return rfidCardDtos.filter(rfid => (rfid.idTag != 'freecharge' && (rfid.userId == null || rfid.userId.length == 0)));
  }
  filterAssignedRfidCards(rfidCardDtos: RfidCardDto[]): RfidCardDto[] {
    return rfidCardDtos.filter(rfid => rfid.idTag === 'freecharge' || (rfid.userId != null && rfid.userId.length > 0));
  }


  addTagPromise(name) {
    if (this.isRfidCardIdTagValid(name) == false) {
      this.showToastRfidCardInvaild(name);
      return;
    }

    if (this.isRfidCardIdTagAvailable(name) == false)
      return;

    this.cacheIdTag = "";
    return plainToClass(RfidCardDto, { customerId: this.customerId, idTag: name });;
  }

  sendInviteEmail(user: User) {
    const sendInviteRequest: SendInviteRequest = {
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
      clientURI: this.baseUrl + 'auth/register',
      invitingCustomerId: this.customerId ? this.customerId : 0
    }

    this.authenticationService.sendInvite(sendInviteRequest).subscribe(result => {
      this.inviteLink = result.inviteLink;
      //var input: HTMLInputElement = <HTMLInputElement>document.getElementById('inviteLink');
      //input.value = result.inviteLink;
      this.btnSaveDisabled = false;
      this.spinner.hide();
      this.newUserEvent.emit(user);
    }, error => {
      this.spinner.hide();
    })
  }

  isCharAllowed(charCode: number): boolean {
    const char = String.fromCharCode(charCode);
    const result = (/^[0-9a-fA-F]+$/).test(char);
    return result;
  }

  isRfidCardIdTagValid(value: string): boolean {

    if (value === null || value === undefined || value.length > this.rfidTagMaxLength || value.length < this.rfidTagMinLength)
      return false;

    for (var index = 0; index < value.length; index++) {
      if (this.isCharAllowed(value.charCodeAt(index)) == false)
        return false;
    }
    return true;
  }
  isRfidCardIdTagAvailable(value: string): boolean {
    const result = this.assignedRfidCards.some(card => card.idTag.toLowerCase() === value.toLowerCase());

    return !result;
  }
  isRfidCardIdTagConditionMet(value: string) {
    if (value === undefined || value === null) {
      return false;
    }

    return (this.isRfidCardIdTagValid(value) && this.isRfidCardIdTagAvailable(value));
  }

  showToastRfidCardInvaild(TagId: string) {
    this.toastService.error("Ungültige RFID: " + TagId, 0, true);
  }
  showToastRfidCardAlreadyEntered(TagId: string) {
    this.toastService.error("Bereits eingetragen, RFID: " + TagId, 0, true);
  }

  getRfidCardsOfCurrent() {

    if (this.authenticationService.userHasRole('Operator')) {
      this.rfidCardsService.getRfidCardsOfCustomer(this.customerId).subscribe(result => {
        this.availableRfidCards = this.filterAvailableRfidCards(plainToClass(RfidCardDto, result));
        this.assignedRfidCards = this.filterAssignedRfidCards(plainToClass(RfidCardDto, result));
      }, error => { });
    }
    else {
      this.rfidCardsService.getRfidCardsOfCurrentCustomer().subscribe(result => {
        this.availableRfidCards = this.filterAvailableRfidCards(plainToClass(RfidCardDto, result));
        this.assignedRfidCards = this.filterAssignedRfidCards(plainToClass(RfidCardDto, result));
      }, error => { });
    }
  }
}
